// Brand logo for Stainless Drycleaners — clothes-hanger mark + wordmark.
// Uses currentColor so it adapts to light (foreground) and dark sections.

export const LogoMark = ({ className = "" }) => (
  <svg
    viewBox="0 0 48 48"
    className={className}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinejoin="round"
    strokeLinecap="round"
    aria-hidden="true"
  >
    {/* hook */}
    <path d="M24 15 V11 C24 8.2 21.7 6.9 19.9 8.6" />
    {/* shoulders */}
    <path d="M6.5 31 L24 15 L41.5 31" />
    {/* bottom bar */}
    <path d="M6.5 31 H41.5" />
    {/* subtle steam / fold accent */}
    <path d="M17 38 c1.6 -1.5 1.6 -3.2 0 -4.7 M24 38 c1.6 -1.5 1.6 -3.2 0 -4.7 M31 38 c1.6 -1.5 1.6 -3.2 0 -4.7"
          strokeWidth="1.3" opacity="0.5" />
  </svg>
);

const Logo = ({ size = "md", showText = true, className = "", markClass = "" }) => {
  const markSize = size === "lg" ? "h-12" : size === "sm" ? "h-7" : "h-9";
  const titleSize = size === "lg" ? "text-3xl md:text-4xl" : size === "sm" ? "text-lg" : "text-xl md:text-2xl";
  const tagSize = size === "lg" ? "text-[10px] md:text-[11px]" : "text-[8px] md:text-[9px]";

  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <LogoMark className={`${markSize} w-auto shrink-0 ${markClass}`} />
      {showText && (
        <span className="flex flex-col leading-none">
          <span className={`font-display ${titleSize} tracking-[-0.01em]`}>Stainless</span>
          <span className={`${tagSize} tracking-[0.42em] uppercase opacity-55 mt-1.5 font-sans font-medium`}>
            Drycleaners
          </span>
        </span>
      )}
    </span>
  );
};

export default Logo;
